import Component from 'vue-class-component'
import Vue from 'vue'
import { VFlex } from 'vuetify/lib'

@Component({})
export class ProgressoFormWrapper extends Vue {
	render() {
		if (this.$scopedSlots.default) {
			return <VFlex class="form-progress d-flex align-center">{this.$scopedSlots.default(this.$props)}</VFlex>
		}

		return
	}
}

export default ProgressoFormWrapper
